RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Observation = RivalIQ.views.ItemView.mixin({
        template: false,

        className: 'ranking-observation',

        mixins: {
            Props: Marionette.Dashboard.mixins.Props
        },

        loadData: function () {
            const me = this;
            const metric = me.dashboardModel.metrics[0];
            me.rankMetric = me.valueMetric = RivalIQ.metric.freeDimensions(RivalIQ.metric.pin(metric), me.getProp('dimensions'));

            if (RivalIQ.metric.property.metricType(metric) === RivalIQ.enums.metricType.TOTAL) {
                me.valueMetric = RivalIQ.metric.build(me.rankMetric, {
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                });
            }

            return $.when(
                me.getRank(),
                me.getValue()
            ).done(function (rank, value) {
                me.rank = rank;
                me.value = (value ? value : rank);
            });
        },

        getRankString: function () {
            const me = this;
            const companyName = RivalIQ.state.landscape.getCompanyById(me.getProp('companyId')).get('name');
            const metricName = RivalIQ.metric.names.metricName(me.rankMetric, {
                dimensions: ['channel']
            });

            const metricType = RivalIQ.metric.property.metricType(me.valueMetric);
            const otherCompaniesExist = (me.rank.count > 1);
            const rankFormatter = RivalIQ.metric.format.formatFn(me.rankMetric);

            if (!otherCompaniesExist) {
                if (metricType === RivalIQ.enums.metricType.TOTAL) {
                    return RivalIQ.str('metric_rank_total_sole_company', companyName, rankFormatter(me.rank.target.value), metricName);
                } else {
                    return RivalIQ.str('metric_rank_volume_sole_company', companyName, rankFormatter(me.rank.target.value), metricName);
                }
            } else if (metricType === RivalIQ.enums.metricType.TOTAL) {
                return RivalIQ.str('metric_rank_total', companyName, me.rank.target.rank.ordinal(), me.rank.count, metricName);
            } else {
                return RivalIQ.str('metric_rank', companyName, me.rank.target.rank.ordinal(), me.rank.count, metricName);
            }
        },

        createGrowthString: function (value) {
            const formatter = RivalIQ.formatter.absolutePercent;
            return (value >= 0 ?
                RivalIQ.str('metric_value_positive_growth', formatter(value)) :
                RivalIQ.str('metric_value_negative_growth', formatter(Math.abs(value))));
        },

        getValueString: function () {
            const me = this;
            const leaderCompanyId = me.rank.leader.dimensionValue;
            const leaderName = RivalIQ.state.landscape.getCompanyById(leaderCompanyId).get('name');
            const metricType = RivalIQ.metric.property.metricType(me.valueMetric);
            const isLeader = (me.rank.target.rank === 1);

            if (me.rank.data.length <= 1) {
                return;
            }

            if (metricType === RivalIQ.enums.metricType.VOLUME) {
                const rankFormatter = RivalIQ.metric.format.formatFn(me.rankMetric);
                if (isLeader) {
                    const second = me.rank.data[1];
                    return RivalIQ.str('metric_value_volumetric_leading',
                        RivalIQ.state.landscape.getCompanyById(second.dimensionValue).get('name'),
                        rankFormatter(second.value));
                } else {
                    return RivalIQ.str('metric_value_volumetric_trailing', leaderName, rankFormatter(me.rank.leader.value));
                }
            }

            if (metricType === RivalIQ.enums.metricType.TOTAL) {
                if (isLeader) {
                    const secondCompanyId = me.rank.data[1].dimensionValue;
                    const secondGrowth = _.find(me.value.data, {
                        dimensionValue: secondCompanyId
                    });

                    // NOTE this can happen when we have a current period value
                    // but not a compare period value
                    if (!secondGrowth) {
                        return;
                    }

                    return RivalIQ.str('metric_value_total_leading',
                        RivalIQ.state.landscape.getCompanyById(secondCompanyId).get('name'),
                        me.createGrowthString(secondGrowth.value));
                } else {
                    const leaderGrowth = _.find(me.value.data, {
                        dimensionValue: leaderCompanyId
                    });

                    // NOTE this can happen when we have a current period value
                    // but not a compare period value
                    if (!leaderGrowth) {
                        return;
                    }

                    return RivalIQ.str('metric_growth_total_trailing',
                        leaderName,
                        me.createGrowthString(leaderGrowth.value));
                }
            }
        },

        getMissingString: function () {
            const me = this;

            const companyName = RivalIQ.state.landscape.getCompanyById(me.getProp('companyId')).get('name');
            const channelName = RivalIQ.data.channels.get(me.rankMetric.channel).get('name');
            return RivalIQ.str('channel_missing', channelName, companyName);
        },

        getMissingDataString: function () {
            const me = this;

            const timePeriodString = RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'));
            const companyName = RivalIQ.state.landscape.getCompanyById(me.getProp('companyId')).get('name');
            return RivalIQ.str('data_missing', timePeriodString, companyName);
        },

        // TODO when we remove companyData this should be handled by the data
        // response
        presenceMissing: function () {
            const me = this;
            const source = RivalIQ.data.channels.get(me.rankMetric.channel).id;
            return !RivalIQ.state.landscape.getCompanyById(me.getProp('companyId')).hasChannel(source);
        },

        _constructObservationHtml: function () {
            const me = this;

            let html;
            if (_.isNull(me.rank.target.rank) || _.isNull(me.rank.target.value)) {
                html = (me.presenceMissing() ? me.getMissingString() : me.getMissingDataString());
            } else {
                html = $.tagHtml('p', {
                    html: me.getRankString()
                });

                const valueString = me.getValueString();
                if (valueString) {
                    html += $.tagHtml('p', {
                        html: valueString
                    });
                }
            }

            return html;
        },

        _renderTemplate: function () {
            const me = this;

            me.attachElContent(me._constructObservationHtml());
        },

        getRank: function () {
            const me = this;
            return RivalIQ.metric.data.rank(me.rankMetric, me.getProps());
        },

        getValue: function () {
            const me = this;
            if (me.rankMetric !== me.valueMetric) {
                return RivalIQ.metric.data.rank(me.valueMetric, me.getProps());
            }
        }
    });

    const CompanyMetricSummary = RivalIQ.views.LayoutView.mixin({
        className: 'block-chart company-metric-summary',
        template: '#companyMetricSummaryTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'showRank'
        },

        regions: {
            glance: '.x-glance',
            rank: '.rank-insight',
            graph: '.x-graph',
            noData: '.no-data'
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            // handle no data because of missing permissions.
            const widgetInstanceState = me.dashboardModel.getWidgetInstanceState();
            const metric = _.get(me.dashboardModel, ['metrics', 0]);
            if (widgetInstanceState && metric) {
                const source = RivalIQ.metric.property.source(metric);
                const focusCompanyHasInsights = _.find(widgetInstanceState.companies, {
                    id: me.getProp('focusCompanyId')
                });

                if (source && RivalIQ.enums.sourceDetails[source].privateData &&
                    (!focusCompanyHasInsights || !_.get(focusCompanyHasInsights, ['sources', source, 'validToken']))) {
                    const View = RivalIQ.apps.Insights.views.getNoPresenceView(RivalIQ.metric.property.source(metric));
                    const view = new View({
                        dashboardModel: me.dashboardModel
                    });
                    me.noData.show(view);
                    return;
                }
            }

            me.showGlance();
            me.showGraph();
            me.showRank();
        },

        showGlance: function () {
            const me = this;
            const widget = me.dashboardModel.getWidget('glance');
            me.glance.showWidget(widget);
        },

        showGraph: function () {
            const me = this;
            const widget = me.dashboardModel.getWidget('graph');
            me.graph.showWidget(widget);
        },

        showRank: function () {
            const me = this;

            const view = new Observation({
                dashboardModel: me.dashboardModel
            });

            me.rank.show(view);
        }
    });

    const STATIC_GRAPH_HEIGHT = 264;
    const CompanyMetricSummaryWidget = RivalIQ.apps.Dashboard.widgets.ChartWidget.mixin({
        mixins: {
            focusCompanyTitlePlacementMixin: App.mixins.FocusCompanyTitlePlacementMixin
        },

        title: function () {
            const me = this;
            if (me.getProp('title')) {
                return me.getProp('title');
            }

            return [
                me.getChartTitle(),
                'Summary'
            ].join(' ');
        },

        exportFormats: [
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG
        ],

        view: CompanyMetricSummary,
        isSupported: function (props) {
            return Boolean(props.metrics) && props.metrics.length === 1 &&
                RivalIQ.metric.graph.hasHistory(props.metrics[0]);
        },
        propValues: {
            timeAnalysisMode: [
                RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
            ]
        },
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                dimensions: ['companyId'],
                companyId: props.focusCompanyId,
                focusCompanyTitlePlacement: RivalIQ.enums.widgetFocusCompanyTitlePlacement.PREFIX,
                useUniversalMetricsApi: me.curation.isCustomDashboard
            });

            props.submetricDisplayType = 'upDownCarets';
            props.focusCompanyOnly = !props.showBenchmarkLine;

            me.metrics = me.buildMetrics(props);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            return [
                {
                    instanceId: 'glance',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        companyId: props.focusCompanyId,
                        submetricType: 'delta_relative'
                    }
                },
                {
                    instanceId: 'graph',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_COMPANY_LINE_CHART,
                    props: {
                        companyId: undefined,
                        height: STATIC_GRAPH_HEIGHT,
                        omitGraphTitle: true
                    }
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.COMPANY_METRIC_SUMMARY, CompanyMetricSummaryWidget);
});
